export function enableToLabel (data) {
    if (Number(data) === 0) {
        return '启用';
    }
    if (Number(data) === 1) {
        return '停用';
    }
}

export function enableToStatus (data) {
    if (String(data) === '启用') {
        return '0';
    }
    if (String(data) === '停用') {
        return '1';
    }
}

export function blackToStatus (data) {
    if (String(data) === '是') {
        return '1';
    }
    if (String(data) === '否') {
        return '0';
    }
}

export function userTypeToLabel (data) {
    if (String(data) === '1') {
        return '主账号';
    }
    if (String(data) === '2') {
        return '子账号';
    }
}

export function userTypeToStatus (data) {
    if (String(data) === '主账号') {
        return '1';
    }
    if (String(data) === '子账号') {
        return '2';
    }
}

export function accountTypeToLabel (data) {
    if (String(data) === '1') {
        return '供应商';
    }
    if (String(data) === '2') {
        return '司机';
    }
    if (String(data) === '3') {
        return '银行';
    }
}

export function classifyToStatus(data) {
    if (data === '国内（非营利机构）') {
        return '4';
    }
    if (data === '国外、港澳台') {
        return '3';
    }
    if (data === '国内（个人）') {
        return '2';
    }
    if (data === '国内（公司、个体户）') {
        return '1';
    }
}

export function enableFlagToLabel(data) {
    if (String(data) === '0') {
        return '生效';
    }
    if (String(data) === '1') {
        return '失效';
    }
}

export function vehicleStatusToLabel(data) {
    if (String(data) === '0') {
        return '启用';
    }
    if (String(data) === '1') {
        return '停用';
    }
}

export function driverBlackFlagToLabel(data) {
    if (String(data) === '0') {
        return '否';
    }
    if (String(data) === '1') {
        return '是';
    }
}

export function driverIdentificationToLabel(data) {
    if (String(data) === '1') {
        return '是';
    }
    if (String(data) === '2') {
        return '否';
    }
}

export function driverStatusToLabel(data) {
    if (String(data) === '0') {
        return '启用';
    }
    if (String(data) === '1') {
        return '停用';
    }
}

export function hunterStatusToLabel(data) {
    if (String(data) === '1') {
        return '找货中';
    }
    if (String(data) === '2') {
        return '已失效';
    }
    if (String(data) === '3') {
        return '找货成功';
    }
}

export function commonRouteToLabel(data) {
    if (String(data) === '0') {
        return '是';
    }
    if (String(data) === '1') {
        return '否';
    }
}
export function lclLogoToLabel(data) {
    if (String(data) === '2') {
        return '零担';
    }
    if (String(data) === '1') {
        return '整车';
    }
}
export function accountModeLabel(data) {
    if (String(data) === 'A') {
        return '线上';
    }
    if (String(data) === 'B') {
        return '线下';
    }
}